










import Vue from 'vue'

export default Vue.extend({
  props: {
    isActive: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    toggle() {
      this.$emit('toggled')
    },
  },
})
